import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { typeLabel } from "@/utils/media";

export default function HotList({ items }: { items: Movie[] }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {items.map((movie, i) => (
        <Link
          key={movie.id}
          to={`/detail/${movie.id}`}
          className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-300 hover:bg-primary-50/60"
        >
          <span className="w-8 shrink-0 text-center font-heading text-2xl font-extrabold text-primary-500/80">
            {i + 1}
          </span>
          <div className="h-[76px] w-[54px] shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={movie.poster}
              alt={`${movie.title} 海报`}
              title={`${movie.title} - ${typeLabel(movie.type)} - 蘑菇视频`}
              className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="truncate font-heading text-base font-semibold text-foreground-950">
              {movie.title}
            </h3>
            <p className="mt-1 truncate text-xs text-foreground-500">
              {typeLabel(movie.type)} · {movie.genres.join(" · ")}
            </p>
            <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1 text-primary-600">
                <i className="ri-star-fill text-[11px]" />
                {movie.rating.toFixed(1)}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-fire-line" />
                {movie.popularity}
              </span>
            </div>
          </div>
          <i className="ri-play-circle-line text-2xl text-foreground-300 transition-colors group-hover:text-primary-500" />
        </Link>
      ))}
    </div>
  );
}